import { randomId } from '../../util/randomId';
import { admin, client, designer } from './user';
import type { ViewerContext_UserFragment } from '../../lib/ViewerContext.generated';

export const createViewerUser = (
    props: Partial<ViewerContext_UserFragment>
): ViewerContext_UserFragment => {
    const userId = props.id || randomId(1000, 100000) + '';
    return {
        __typename: 'User',
        id: userId,
        displayName: 'user-' + userId,
        isAdmin: false,
        isDesigner: false,
        isCertifiedDesigner: false,
        isPartnershipDesigner: false,
        designerLevel: 'ENTRY',
        certifications: [],
        hasRejectedDesignerCertification: false,
        ...props,
    };
};

export const clientViewer: ViewerContext_UserFragment = createViewerUser(client);
export const designerViewer: ViewerContext_UserFragment = createViewerUser(designer);
export const adminViewer: ViewerContext_UserFragment = createViewerUser(admin);
